
<div>
    <button class="btn" :class="classes" type="button" @click.prevent="openLoginModal">
        <i class="far fa-user"></i>{{ $locale == 'es' ? 'Iniciar sesión' : 'Login' }}
    </button>

    <LoginModal ref="loginModal"/>
</div>
